<div class="destinatariosPanel">

  <!-- título -->
  <div>
    <label class="labelclasic">
      {{titulo}}
    </label>
  </div>


  <div class="contenedorCorreo" [ngClass]="{'focus' : focus}" (click)="correoInput.focus();">

      <!-- correos agregardos -->
      <div *ngFor="let correo of correos; index as index">

          <div class="correoAgregado">

              <div class="input-group-addon correo">
                  {{correo}}
              </div>

              <div class="eliminarBtn" (click)=" QuitarCorreo(index); ">
                  <span class="fa fa-times"></span>
              </div>

          </div>

      </div>

      <!-- input -->
      <div class="escribirCorreo">

          <input [ngStyle]="estilo" [(ngModel)]="correoaux" id="correoInput{{id}}" (ngModelChange)="AjusarDimensionesNuevaEntrada()" class="correoinput text-lowercase" type="email"
           #correoInput (keydown.enter)="AgregarCorreo($event)" (keydown.space)="AgregarCorreo($event)" (keydown.,)="AgregarCorreo($event)" (focus)="focus = true"(blur)="AgregarCorreo($event); focus = false">
           <div class="contenedorContenido">
                <span class="contenedorInput" #contenedorInput></span>
            </div>
      </div>

  </div>

  <span *ngIf="verError" class="textoError" [hidden]="!verError || correos.length > 0 || (!errorActivo && !correoTouched)">
      {{mensajeError ? mensajeError : ('DatoIncompeto' | translate)}}
  </span>

</div>
